import React, { useState, useEffect, useRef } from "react";
import Form from "../AdvancedCrud/AdvancedForm";
import { validateSchema } from "../../lib/validator";
import { addRule } from "../AdvancedCrud/rule";
import { addComponent, getFormSchema } from "../AdvancedCrud/schemahelper";
export default ({ schema, Layout, name, ...rest }) => {
  const Component = ({ value, onChange }) => {
    const ref = useRef();
    const onStateChange = (state) => {
      if (!state) return;
      if (state.fields === value) return;
      onChange(state.fields);
    };
    useEffect(() => {
      if (value !== ref.current.fields) {
        ref.current.setFields(value);
      }
    }, [value]);
    return (
      <Form
        defaultValue={undefined}
        schema={schema}
        ref={ref}
        onStateChange={onStateChange}
        Layout={Layout}
        {...rest}
      />
    );
  };
  const Validator = (value) => {
    let sch = getFormSchema(schema, {}, false);
    let errors = validateSchema(sch, value);
    if (errors && Object.keys(errors).length)
      return Object.values(errors)
        .filter((d) => !!d)
        .join(";");
    return true;
  };
  //TODO 保证唯一性，或可多次注册
  addRule(name, Validator);
  addComponent(name, Component);
  return Component;
};
